import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { BranchDto } from './branch.dto';
import { EnvConfigService } from 'app/env-config.service';

export interface BranchList {
  totalCount: number;
  data: BranchDto[];
}

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  envConfig = inject(EnvConfigService);

  constructor(private http: HttpClient) {}

  // Get all branches (non-paginated)
  findAll(): Observable<BranchDto[]> {
    return this.http.get<BranchDto[]>(`/api/user-management/branches`);
  }

  // Get branch by ID
  getById(id: number | string): Observable<BranchDto> {
    return this.http.get<BranchDto>(`/api/user-management/branches/${id}`);
  }

  // Paginated / filtered branches for table
  findRecords(
    sort = 'id,asc',
    pageIndex = 0,
    pageSize = 10,
    
    filters?: { [key: string]: string | number }
  ): Observable<BranchList> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('size', pageSize.toString())
      .set('sort', sort);

    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== undefined && filters[key] !== null) {
          params = params.set(key, filters[key].toString());
        }
      });
    }

    return this.http
      .get<BranchDto[]>(`/api/user-management/branches/search`, {
        observe: 'response',
        params,
      })
      .pipe(
        map((response) => ({
          data: response.body || [],
          totalCount: +response.headers.get('X-Total-Count') || 0,
        }))
      );
  }

  // Create a new branch
  createBranch(branch: BranchDto): Observable<BranchDto> {
    return this.http.post<BranchDto>(`/api/user-management/branches`, branch);
  }

  // Update an existing branch
  updateBranch(branch: BranchDto): Observable<BranchDto> {
    return this.http.put<BranchDto>(`/api/user-management/branches`, branch);
  }

  // Delete a branch by ID
  deleteBranch(id: number | string): Observable<void> {
    return this.http.delete<void>(`/api/user-management/branches/${id}`);
  }
}
